import React, { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    age: 42,
    location: 'San Francisco, CA',
    treatment: 'Bioidentical Hormone Therapy',
    rating: 5,
    quote: 'After struggling with fatigue and mood swings for years, VitalMed\'s hormone therapy has completely transformed my life. I feel like myself again!',
    image: 'https://public.readdy.ai/ai/img_res/39d5c6ff9bb2a2045344113074e0aee5.jpg',
    results: ['80% increase in energy', 'Improved sleep quality', 'Balanced mood']
  },
  {
    id: 2,
    name: 'Michael Chen',
    age: 38,
    location: 'Austin, TX',
    treatment: 'Peptide Therapy',
    rating: 5,
    quote: 'The peptide therapy program exceeded my expectations. My recovery time has improved dramatically, and I feel stronger than I have in years.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20athletic%20Asian%20man%20in%20his%20thirties%2C%20confident%20smile%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20business%20casual%20attire%2C%20healthy%20and%20energetic%20appearance%2C%20high-quality%20portrait&width=400&height=400&seq=testimonial-michael&orientation=squarish',
    results: ['50% faster recovery', 'Increased muscle mass', 'Enhanced performance']
  },
  {
    id: 3,
    name: 'Jennifer Rodriguez',
    age: 35,
    location: 'Miami, FL',
    treatment: 'NAD+ Treatment',
    rating: 5,
    quote: 'The NAD+ therapy has given me mental clarity I haven\'t experienced in years. The virtual consultations made everything so convenient.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Hispanic%20woman%20in%20her%20thirties%2C%20bright%20smile%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20professional%20attire%2C%20vibrant%20and%20healthy%20appearance%2C%20high-quality%20portrait%20photography&width=400&height=400&seq=testimonial-jennifer&orientation=squarish',
    results: ['Improved focus', 'Increased energy', 'Better cognitive function']
  },
  {
    id: 4,
    name: 'David Thompson',
    age: 45,
    location: 'Seattle, WA',
    treatment: 'Comprehensive Wellness',
    rating: 5,
    quote: 'The comprehensive approach addressed all my health concerns. The team\'s expertise and personalized care made all the difference.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20middle-aged%20businessman%20with%20friendly%20smile%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20business%20attire%2C%20confident%20and%20approachable%20appearance%2C%20high-quality%20executive%20portrait&width=400&height=400&seq=testimonial-david&orientation=squarish',
    results: ['Overall health improvement', 'Weight optimization', 'Stress reduction']
  }
];

const TestimonialsSection: React.FC = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Patient <span className="text-teal-600">Success Stories</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real results from real patients who have transformed their health through our 
            <strong> personalized telemedicine treatments</strong>.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <div className="flex items-center mb-6">
                <img 
                  src={testimonials[activeTestimonial].image} 
                  alt={testimonials[activeTestimonial].name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h3 className="text-xl font-bold text-gray-900">{testimonials[activeTestimonial].name}</h3>
                  <p className="text-gray-600 text-sm">
                    Age {testimonials[activeTestimonial].age} • {testimonials[activeTestimonial].location}
                  </p>
                  <div className="flex items-center mt-1">
                    {[...Array(testimonials[activeTestimonial].rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                </div>
              </div>
              
              <div className="mb-6">
                <span className="inline-block px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium mb-4">
                  {testimonials[activeTestimonial].treatment}
                </span>
                <blockquote className="text-gray-700 text-lg leading-relaxed italic">
                  "{testimonials[activeTestimonial].quote}"
                </blockquote>
              </div>
              
              <div>
                <h4 className="font-semibold text-gray-900 mb-3">Key Results:</h4>
                <div className="space-y-2">
                  {testimonials[activeTestimonial].results.map((result, index) => (
                    <div key={index} className="flex items-center">
                      <i className="ri-check-double-line text-teal-600 mr-2"></i>
                      <span className="text-gray-700 text-sm">{result}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="grid grid-cols-2 gap-4">
              {testimonials.map((testimonial, index) => (
                <button
                  key={testimonial.id}
                  onClick={() => setActiveTestimonial(index)}
                  className={`p-4 rounded-xl transition-all duration-300 cursor-pointer ${
                    activeTestimonial === index 
                      ? 'bg-teal-600 text-white shadow-lg' 
                      : 'bg-white text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover object-top mx-auto mb-3"
                  />
                  <h4 className="font-semibold text-sm mb-1">{testimonial.name}</h4>
                  <p className="text-xs opacity-80">{testimonial.treatment}</p>
                  <div className="flex justify-center mt-2">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className={`ri-star-fill text-xs ${
                        activeTestimonial === index ? 'text-yellow-300' : 'text-yellow-400'
                      }`}></i>
                    ))}
                  </div>
                </button>
              ))}
            </div>
            
            <div className="mt-8 text-center">
              <div className="bg-white rounded-xl p-6 shadow-lg">
                <div className="text-3xl font-bold text-teal-600 mb-2">98%</div>
                <div className="text-gray-700 font-semibold mb-1">Patient Satisfaction</div>
                <div className="text-gray-500 text-sm">Based on 2,500+ reviews</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <button className="px-8 py-3 bg-teal-600 text-white rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-chat-quote-line mr-2"></i>
            Read More Success Stories
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;